import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("soarlife-lang") || "en";
    } catch {
      return "en";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("soarlife-lang", l);
    } catch {
      /* noop */
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang === "ht" ? "ht" : "en";
  }, [lang]);

  const t = (key) => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] || entry.en || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useT = () => useContext(LanguageContext);
